import { Link } from "react-router-dom";
import { ScanLine, ShieldCheck, Plane, Ship, Truck, Package } from "lucide-react";
import { HERO_IMG } from "../lib/api";

export default function HowItWorks() {
  const steps = [
    { n: "01", icon: <ScanLine />, title: "Search by VIN or vehicle", text: "Enter your 17-character VIN for exact matches, or pick your make, model and year. We decode everything automatically." },
    { n: "02", icon: <Package />, title: "Compare & add to cart", text: "Browse agent-verified listings, compare specs, compatibility, and price. Rare parts included." },
    { n: "03", icon: <ShieldCheck />, title: "48-hour availability lock", text: "Your payment is held in escrow for up to 48 hours while our network physically confirms the part." },
    { n: "04", icon: <Plane />, title: "Pick air or sea freight", text: "Rush (3–7 days) by air, or cost-effective (21–45 days) by sea. Customs clearance is on us." },
    { n: "05", icon: <Truck />, title: "Last-mile delivery", text: "Local agents coordinate clearance and hand-off from Lagos to Mombasa to Accra and beyond." },
  ];

  return (
    <main className="bg-white" data-testid="how-it-works-page">
      <section className="relative bg-[#121212] text-white py-20">
        <div
          className="absolute inset-0 opacity-30"
          style={{ backgroundImage: `url(${HERO_IMG})`, backgroundSize: "cover" }}
        />
        <div className="relative max-w-[1100px] mx-auto px-4 lg:px-8 text-center">
          <div className="text-[11px] font-bold uppercase tracking-widest text-[#FFD100] mb-3">How Auto Parts Africa works</div>
          <h1 className="font-display text-5xl lg:text-6xl font-extrabold tracking-tight mb-5">
            From <span className="text-[#FFD100]">VIN</span> to your <span className="text-[#009A44]">garage</span>.
          </h1>
          <p className="text-zinc-300 text-lg max-w-2xl mx-auto">
            A fulfillment layer that treats African mechanics, workshops and car owners as first-class citizens — not an after-thought.
          </p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-4 lg:px-8 py-20">
        <div className="space-y-10">
          {steps.map((s, i) => (
            <div key={s.n} className="grid md:grid-cols-[100px_60px_1fr] gap-5 md:gap-8 items-start">
              <div className="font-display text-5xl md:text-7xl font-extrabold text-[#009A44]">{s.n}</div>
              <div className="w-14 h-14 bg-[#121212] text-white flex items-center justify-center shrink-0">{s.icon}</div>
              <div>
                <h2 className="font-display text-2xl md:text-3xl font-extrabold mb-2">{s.title}</h2>
                <p className="text-zinc-600 leading-relaxed max-w-2xl">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#009A44] text-white py-20">
        <div className="max-w-[900px] mx-auto px-4 lg:px-8 text-center">
          <h2 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight mb-5">
            Ready to find your part?
          </h2>
          <p className="mb-8 text-white/90">
            Search by VIN — the quickest, most accurate way to find compatible parts.
          </p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/" className="bg-white text-[#009A44] px-8 py-4 font-bold uppercase tracking-wider hover:bg-[#FFD100] hover:text-[#121212] transition-colors">Search by VIN</Link>
            <Link to="/register?role=mechanic" className="border-2 border-white px-8 py-4 font-bold uppercase tracking-wider hover:bg-white hover:text-[#009A44] transition-colors">Mechanic signup</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
